import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Separator } from "../ui/separator";

const PrivacyPolicy = (): JSX.Element => {
  return (
    <div className="container mx-auto py-8 px-4 max-w-4xl">
      <Card className="border-t-4 border-t-brand-gold">
        <CardHeader className="space-y-2">
          <CardTitle className="text-2xl">Privacy Policy</CardTitle>
          <CardDescription className="text-sm">
            Last Updated: 01/10/2025<br />
            Version: 1.4.0
          </CardDescription>
        </CardHeader>
        <CardContent className="prose max-w-none space-y-8">
          <div className="bg-muted/50 p-6 rounded-lg">
            <p className="text-lg leading-relaxed">
              This Privacy Policy explains how UENETWORK LTD ("Company", "we", "us", or "our") collects, uses, 
              and protects your personal data when using Upper Echelon.
            </p>
          </div>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold flex items-center gap-2">
              <span className="text-brand-gold">1.</span> Data Collection
            </h2>
            <Separator className="my-2" />
            <div className="pl-6 space-y-4">
              <p>We may collect the following data:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Personal information (name, email, date of birth)</li>
                <li>Financial information (bank account details, payment information)</li>
                <li>Account-related data</li>
                <li>Usage data, such as cookies and analytics information</li>
              </ul>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold flex items-center gap-2">
              <span className="text-brand-gold">2.</span> Use of Data
            </h2>
            <Separator className="my-2" />
            <div className="pl-6 space-y-4">
              <p>Your data may be used for:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Providing and improving our services</li>
                <li>Communication purposes</li>
                <li>Ensuring security and compliance with legal obligations</li>
              </ul>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold flex items-center gap-2">
              <span className="text-brand-gold">3.</span> Data Sharing
            </h2>
            <Separator className="my-2" />
            <div className="pl-6 space-y-4">
              <p>
                We do not sell your personal data. However, we may share it with:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Service providers assisting with operations</li>
                <li>Payment processors and financial institutions (only as necessary for processing payments)</li>
                <li>Legal authorities if required by law</li>
              </ul>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold flex items-center gap-2">
              <span className="text-brand-gold">4.</span> Data Security
            </h2>
            <Separator className="my-2" />
            <div className="pl-6 space-y-4">
              <p>
                We take reasonable measures to protect your data but cannot guarantee absolute security.
                We implement industry-standard encryption and security measures to protect sensitive financial information.
                Bank details are stored in encrypted form and access is strictly controlled.
              </p>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold flex items-center gap-2">
              <span className="text-brand-gold">5.</span> Your Rights
            </h2>
            <Separator className="my-2" />
            <div className="pl-6 space-y-4">
              <p>You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access, correct, or delete your data</li>
                <li>Withdraw consent for data processing where applicable</li>
              </ul>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold flex items-center gap-2">
              <span className="text-brand-gold">6.</span> Changes to this Policy
            </h2>
            <Separator className="my-2" />
            <div className="pl-6 space-y-4">
              <p>
                We may update this policy and will notify users of significant changes.
              </p>
            </div>
          </section>
        </CardContent>
      </Card>
    </div>
  );
};

export default PrivacyPolicy; 